<template>
  <div class="dvClientFormBox">

    <div class="dvClientConsent">
      <div class="dvClientConsentContent">
        <h3>Data Privacy Notice</h3>
        <p>
          Ayala Land International Sales, Inc. (referred to as "Company") respects your privacy and is committed to protecting your personal data. We strive to provide a safe, secure online experience and ensure that we comply with the Data Privacy Act of 2012.
        </p>
        <p>
          This Privacy Notice sets forth the online data collection, usage, maintenance, disclosure and security that apply when you disclose your personal information in connection with the Company website (together referred to as "Site") and the services provided through it, such as client inquiries, slot reservation, or booking facility (referred to as the “Services”).
        </p>
        <p>
          As a fully-owned subsidiary of Ayala Land, Inc., the Company processes information pursuant to the Ayala Land Group Privacy Notice. We have highlighted here our privacy notice and practices specific to the Company and this website. To know more about how we process your Personal Information within the Group, please visit the following links: <a href="https://www.atayala.com/privacy-notice" target="_blank">https://www.atayala.com/privacy-notice</a> and <a href="https://www.atayala.com/terms-and-conditions" target="_blank">https://www.atayala.com/terms-and-conditions</a>
        </p>
      </div> <!-- dvClientConsentContent -->
      <div class="dvClientConsentConfirm">
        <div class="dvClientConsentConfirmTitle">
          <h3>Certification and Data Privacy Consent</h3>
          <h4>
            * Required
          </h4>
        </div>

        <div class="dvClientConsentConfirmCheckbox">
          <label><input type="checkbox" v-model="dataPrivacy.isAgree" :disabled="dataPrivacy.isAgreeDisabled" class="filled-in selectAllCheckbox"><span></span></label>
          <div class="dvClientConsentConfirmCheckboxLabel">I have read and agreed with the <a href="https://www.atayala.com/privacy-notice" target="_blank">Privacy Notice</a> and <a href="https://www.atayala.com/terms-and-conditions" target="_blank">Terms and Conditions</a>.</div>
        </div>

      </div> <!-- dvClientConsentConfirm -->

    </div><!-- dvClientConsent -->


  </div> <!-- dvClientFormBox -->
</template>

<script>

  export default {
    name: 'data-privacy-concent',
    props: ['dataPrivacy'],
    data: () => ({
    }),
    methods: {
    },
    mounted() {
    },
    created() {
    }
  }
</script>
